import type { ViewStyle } from 'react-native'
import type { ThemeMode } from '../hooks/useTheme'

/** Final turn-panel treatment: Firm well · relaxed. */
export const TURN_PANEL_COLORS = {
  light: { background: '#d8cba4', card: '#f6efd9', border: '#738348', highlight: '#ffffff99' },
  dark: { background: '#10170b', card: '#303923', border: '#8aa14a', highlight: '#a5b86c33' },
} as const

/**
 * Team games: the attack popup's warning when the target is a teammate's
 * territory. `accent` is the card border; `fill` backs the white "Teammate"
 * chip and the "Attack teammate" button, so it stays dark enough for white
 * text in both themes.
 */
export const TEAMMATE_WARNING_COLORS = {
  light: { accent: '#b45309', fill: '#b45309' },
  dark: { accent: '#fbbf24', fill: '#b45309' },
} as const

export const TURN_CARD_SPACING = {
  borderWidth: 2, borderRadius: 10, paddingY: 10, paddingX: 12,
  placementGap: 10, placementActionsTop: 2,
  desktopMargin: 4, rowMargin: 0, rowPaddingLeft: 8, rowPaddingRight: 16, counterInset: 8,
} as const

export function turnCardStyle(theme: ThemeMode, isDesktop: boolean): ViewStyle {
  const colors = TURN_PANEL_COLORS[theme]
  return {
    backgroundColor: colors.card, borderColor: colors.border,
    borderWidth: TURN_CARD_SPACING.borderWidth, borderRadius: TURN_CARD_SPACING.borderRadius,
    paddingHorizontal: TURN_CARD_SPACING.paddingX, paddingVertical: TURN_CARD_SPACING.paddingY,
    gap: TURN_CARD_SPACING.placementGap,
    marginHorizontal: isDesktop ? TURN_CARD_SPACING.desktopMargin : 0,
  }
}

export function turnPhaseRowStyle(isDesktop: boolean): ViewStyle {
  return {
    flexDirection: 'row', alignItems: 'center',
    marginHorizontal: isDesktop ? TURN_CARD_SPACING.desktopMargin : TURN_CARD_SPACING.rowMargin,
    paddingLeft: TURN_CARD_SPACING.rowPaddingLeft,
    paddingRight: TURN_CARD_SPACING.rowPaddingRight,
  }
}
